import { render, staticRenderFns } from "./BaseTransaction.vue?vue&type=template&id=b1674a7e&"
import script from "./BaseTransaction.vue?vue&type=script&lang=js&"
export * from "./BaseTransaction.vue?vue&type=script&lang=js&"
import style0 from "./BaseTransaction.vue?vue&type=style&index=0&id=b1674a7e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports